export function fromLegacy(filter) {
  return {
    id: filter.$id.replace('/savedSearches/', ''),
    name: filter.$description,
    expression: filter.where,
    nodeId: filter.nodeId,
  };
}

export function toLegacy(filter) {
  return {
    $id: `/savedSearches/${filter.id}`,
    $description: filter.name,
    where: filter.expression,
  };
}
